import { isATCEnabled } from './isATCEnabled';
import { publishSponsoredContent } from '../publisher';

/**
 * Sends sponsored content product render rate metrics
 * @param {Array} products - Array of product objects
 * @param {boolean} loading - Loading state to avoid sending data during loading
 */
export const sendSponsoredContentAnalytics = (products, loading = false) => {
  if (loading || !(products?.length > 0)) {
    return;
  }

  const requestedProducts = products;
  const renderedProducts = requestedProducts.filter((product) => isATCEnabled(product));
  const requestedSponsoredProducts = requestedProducts.filter((product) => product.info?.isSponsored);
  const renderedSponsoredProducts = renderedProducts.filter((product) => product.info?.isSponsored);

  if (requestedSponsoredProducts.length > 0) {
    publishSponsoredContent(
      requestedProducts.length,
      renderedProducts.length,
      requestedSponsoredProducts.length,
      renderedSponsoredProducts.length
    );
  }
};